import { Button, Card, Drawer, Skeleton } from "antd";
import { useContext, useEffect, useState } from "react";
import { useQuery } from "react-query";
import { SettingContext } from "../../routes";
import HTTP from "../../services/httpService";
import { downloadCSV, formatDate, getUserRole } from "../../services/util";
import CustomHeader from "../common/Header";
import CustomTable from "../common/Table";
import HotelWiseLikeDislike from "./HotelWiseLikeDislike";
import { useLocation } from "react-router-dom";

function LikeDislikeTable() {
    const { state } = useLocation();

    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const { selectedDates, selectedHotels } = useContext(SettingContext);
    const [start_date, end_date] = selectedDates;
    const [tableData, setTableData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [drawerVisibility, setDrawerVisibility] = useState(false);
    const [detailsQuotesId, setDetailsQuotesId] = useState("");
    const hotel_ids = selectedHotels;

    const [sortedInfo, updateSortedInfo] = useState({
        order: "descend",
        columnKey: state.from,
    });
    const [formData, setFormData] = useState({
        start_date: formatDate(start_date),
        end_date: formatDate(end_date),
        page: 0,
        limit: 10,
        staff_id,
        hotel_ids,
        all_selected: hotel_ids.length > 0 ? false : true,
        sort_by: sortedInfo.columnKey,
        sorting: sortedInfo.order === "ascend" ? 2 : 1,
    });

    const {
        status: likeDislikeStatus,
        data: likeDislikeRes,
        refetch: getLikeDislike,
    } = useQuery(
        "/like-dislike",
        async () => {
            return await HTTP("/dashboard/getLikeDislikes", { ...formData });
        },
        {
            enabled: false,
        },
    );

    useEffect(() => {
        getLikeDislike();
    }, []);

    useEffect(() => {
        getLikeDislike();
    }, [formData]);

    useEffect(() => {
        if (likeDislikeStatus === "success") {
            const { data: tableData, total } = likeDislikeRes;
            setTableData(tableData);
            setTotalRecords(total);
        }
    }, [likeDislikeStatus, likeDislikeRes]);

    function handleTableChange(pagination, _, sorter) {
        const { current, pageSize } = pagination;
        const { order, columnKey } = sorter;
        const others = {
            page: current - 1,
            limit: pageSize,
        };
        if (order !== undefined) {
            others.sorting = order === "ascend" ? 2 : 1;
            others.sort_by = columnKey;
            updateSortedInfo({ columnKey, order });
        } else {
            delete formData.sorting;
            delete formData.sort_by;
            updateSortedInfo({});
        }

        const newFormData = {
            ...formData,
            ...others,
        };

        setFormData(newFormData);
    }

    function toggleDrawerVisibility() {
        setDrawerVisibility(!drawerVisibility);
    }

    function showHotelLikeDisLikeDetails(quotes_id) {
        toggleDrawerVisibility();
        setDetailsQuotesId(quotes_id);
    }

    function closeDetailsDrawer(params) {
        toggleDrawerVisibility();
        setDetailsQuotesId("");
    }

    const column = [
        {
            title: "Quotes",
            dataIndex: "quotes",
            key: "quotes",
            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "quotes" ? sortedInfo.order : null,
        },
        {
            title: "Likes",
            dataIndex: "like_count",
            key: "like_count",
            render: (text, record) => (
                <Button
                    type="link"
                    onClick={() => {
                        showHotelLikeDisLikeDetails(record.quotes_id);
                    }}
                >
                    {text}
                </Button>
            ),
            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "like_count" ? sortedInfo.order : null,
        },
        {
            title: "Dislikes",
            dataIndex: "dislike_count",
            key: "dislike_count",
            render: (text, record) => (
                <Button
                    type="link"
                    onClick={() => {
                        showHotelLikeDisLikeDetails(record.quotes_id);
                    }}
                >
                    {text}
                </Button>
            ),
            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "dislike_count"
                    ? sortedInfo.order
                    : null,
        },
    ];

    useEffect(() => {
        const hotel_ids = selectedHotels;
        setFormData({
            ...formData,
            hotel_ids,
            page: 0,
            all_selected: hotel_ids.length === 0 ? true : false,
        });
    }, [selectedHotels]);

    useEffect(() => {
        let [start_date, end_date] = selectedDates;
        start_date = formatDate(start_date);
        end_date = formatDate(end_date);
        setFormData({
            ...formData,
            start_date,
            page: 0,
            end_date,
        });
    }, [selectedDates]);

    async function downalodReport() {
        const tempFormData = { ...formData };
        delete tempFormData["page"];
        delete tempFormData["limit"];

        const res = await HTTP("/dashboard/getLikeDislikesReport", {
            ...tempFormData,
        });
        downloadCSV(res, `like_dislike_reports`);
    }

    return (
        <>
            <Card className="dashboard-container">
                <CustomHeader
                    extraAfter={
                        (getUserRole() == "Super Admin" ||
                            getUserRole() == "Admin" ||
                            getUserRole() == "Management") && (
                            <Button
                                type="primary"
                                className="margin-right-5"
                                onClick={downalodReport}
                            >
                                Download
                            </Button>
                        )
                    }
                />
                <Card className="box-shadow margin-10">
                    {likeDislikeStatus !== "loading" &&
                    likeDislikeStatus !== "idle" ? (
                        <CustomTable
                            columns={column}
                            tableData={tableData}
                            noOfrecords={totalRecords}
                            currentPage={formData.page + 1}
                            handleTableChange={handleTableChange}
                            className="likeDisLikeTable"
                            rowKey="id"
                        />
                    ) : (
                        <Skeleton
                            active
                            title={false}
                            paragraph={{ rows: 20, width: 40 }}
                        />
                    )}
                </Card>
            </Card>
            <Drawer
                placement="right"
                destroyOnHidden
                title="Details"
                open={drawerVisibility}
                onClose={closeDetailsDrawer}
            >
                <div
                    style={{
                        width: "50vw",
                        margin: "15px",
                    }}
                >
                    <HotelWiseLikeDislike quotes_id={detailsQuotesId} />
                </div>
            </Drawer>
        </>
    );
}

export { LikeDislikeTable };
